module.exports = __webpack_public_path__ + "img/loc@2x.d22b9b07.png";